import { render, staticRenderFns } from "./ArOutstandingDetail.vue?vue&type=template&id=70d38a1a&scoped=true"
import script from "./ArOutstandingDetail.vue?vue&type=script&lang=js"
export * from "./ArOutstandingDetail.vue?vue&type=script&lang=js"
import style0 from "./ArOutstandingDetail.vue?vue&type=style&index=0&id=70d38a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d38a1a",
  null
  
)

export default component.exports